











































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import ChevronIcon from 'mdi-vue/ChevronRight';

import Checkbox from '@/components/Checkbox.vue';

@Component({
  components: {
    ChevronIcon,
    Checkbox,
  },
  name: 'PermissionTreeItem',
})
export default class PermissionTreeItem extends Vue {
  @Prop(Object) readonly item!: PermissionItemCheck;
  @Prop({ type: Number, default: 0 }) readonly level!: number;
  @Prop(Number) readonly index!: number;
  @Prop(Boolean) readonly disabled!: boolean;

  permission = this.item;
  open = false;
  value: CheckboxValue = 'UNCHECKED';

  mounted() {
    if (this.permission.checkValue) {
      this.value = this.permission.checkValue;
      this.updateChildCheckbox(this.value);
      this.$emit('checkbox-change', this.value, this.index);
    }
  }

  onChangeCheckbox(value: boolean) {
    this.value = value ? 'CHECKED' : 'UNCHECKED';

    this.updateChildCheckbox(this.value);
    this.$emit('checkbox-change', this.value, this.index);
  }

  updateChildCheckbox(value: CheckboxValue) {
    if (value !== 'CHECKED' && value !== 'UNCHECKED') return;
    if (this.permission.child) {
      this.permission.child = this.permission.child.map((e) => ({
        ...e,
        checkValue: value,
      }));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onCheckboxEvent(value: CheckboxValue, index: number) {
    if (this.permission.child) {
      (this.permission.child[index] as PermissionItemCheck).checkValue = value;

      let checkedCount = 0;
      let partialCount = 0;

      this.permission.child.forEach((e) => {
        const el = e as PermissionItemCheck;
        if (el.checkValue === 'CHECKED') {
          checkedCount += 1;
        } else if (el.checkValue === 'PARTIAL') {
          partialCount += 1;
        }
      });

      if (checkedCount === this.permission.child.length) {
        this.value = 'CHECKED';
      } else if (checkedCount > 0 || partialCount > 0) {
        this.value = 'PARTIAL';
      } else {
        this.value = 'UNCHECKED';
      }

      this.permission.checkValue = this.value;
    }

    this.$emit('checkbox-change', this.value, this.index);
  }

  @Watch('item')
  onItemChange(value: PermissionItemCheck) {
    this.permission = value;
    this.value = value.checkValue;
    this.updateChildCheckbox(value.checkValue);
  }

  toggle() {
    this.open = !this.open;
  }

  private static getCheckValueBoolean(value: CheckboxValue) {
    switch (value) {
      case 'CHECKED':
        return true;
      case 'UNCHECKED':
        return false;
      default:
        return false;
    }
  }
}
